import React from 'react'

//import GlobalSearch from '../../molecules/GlobalSearch'
import EnvironmentName from '../../molecules/EnvironmentName'
import Changelog from '@SonarCX/components/molecules/Changelog'
import EmailHolder from '@SonarCX/components/molecules/EmailHolder'
import TopBarNote from '../../atoms/TopBarNote'
import NotificationBar from '../../molecules/NotificationBar'
import HamburgerMenuV2 from '../../molecules/HamburgerMenuV2'
import UserInfo from '../../molecules/UserInfo'
import ReminderNavAction from '@SonarCX/providers/ReminderNavAction'

import { useBreakpoint } from '../../../providers/BreakpointProvider'
import useStyles from './styles'

interface TopMenuProps {
  statsComponent?: React.ReactNode | undefined
}

const TopMenu: React.FC<TopMenuProps> = ({ statsComponent }) => {
  const { isNotMedium } = useBreakpoint()

  const [open, setOpen] = React.useState(false)

  const classes = useStyles({ hasStats: Boolean(statsComponent) })

  if (isNotMedium) {
    return (
      <div className={classes.root}>
        {statsComponent ?? (
          <div className={classes.searchArea}>
            {/* <GlobalSearch /> */}

            <EnvironmentName />
          </div>
        )}

        <div className={classes.notificationsArea}>
          <Changelog />

          <EmailHolder />

          <ReminderNavAction />

          <TopBarNote />

          <NotificationBar />

          <UserInfo />
        </div>
      </div>
    )
  }

  return (
    <div className={classes.mobileRoot}>
      <div
        style={{
          display: 'flex',
          width: 'calc(100% - 2rem)',
          padding: '0 1rem'
        }}
      >
        <UserInfo setOpen={setOpen} />

        <div className={classes.hamburgerMenu}>
          <div>{statsComponent}</div>

          <ReminderNavAction />

          <TopBarNote />

          <NotificationBar setOpen={setOpen} />

          <HamburgerMenuV2 open={open} setOpen={setOpen} />
        </div>
      </div>
    </div>
  )
}

export default TopMenu
